const isDisabled = process.env.VUE_APP_IS_ROUTE_DISABLED === "true";
export default {
  path: "consultants",
  name: "ConsultantManagement",
  redirect: "consultants",
  component: () => import("@/components/PassThrough"),
  children: [
    {
      path: "/",
      name: "ConsultantManagementIndex",
      component: () => import("@/views/consultants/index.vue"),
      children: [
        {
          path: ":id",
          name: "ShowConsultant",
          components: {
            "consultant-view": () => import("@/views/consultants/show.vue"),
          },
          meta: {
            isDisabled: isDisabled,
          },
        },
      ],
      meta: {
        rule: "isPublic",
        isDisabled: isDisabled,
      },
    },
    {
      path: "consultants/requests",
      name: "ConsultantRequest",
      component: () => import("@/views/consultants/requests/index.vue"),
      children: [
        {
          path: ":id",
          name: "ConsultantRequestShow",
          components: {
            "consultant-view": () =>
              import("@/views/consultants/requests/show.vue"),
          },
          meta: {
            isDisabled: isDisabled,
          },
        },
      ],
      meta: {
        isDisabled: isDisabled,
      },
    },
  ],
};
